import * as FluentIcon from '@fluentui/react-icons';
import React from 'react';
import { ActionsIconFilled } from './icons/ActionsIconFilled';
import { ActionsIconRegular } from './icons/ActionsIconRegular';
export var MoreIcon = function (props) {
    return React.createElement(FluentIcon.MoreHorizontal24Regular, props);
};
export var MoreIconSelected = function (props) {
    return React.createElement(FluentIcon.MoreHorizontal24Filled, props);
};
export var HomeIcon = function (props) {
    return React.createElement(FluentIcon.Home24Regular, props);
};
export var HomeIconSelected = function (props) {
    return React.createElement(FluentIcon.Home24Filled, props);
};
export var CreateIcon = function (props) {
    return React.createElement(FluentIcon.AddCircle24Regular, props);
};
export var CreateIconSelected = function (props) {
    return React.createElement(FluentIcon.AddCircle24Filled, props);
};
export var CreateIconPen = function (props) {
    return React.createElement(FluentIcon.Pen24Regular, props);
};
export var CreateIconPenSelected = function (props) {
    return React.createElement(FluentIcon.Pen24Filled, props);
};
export var FeedbackIcon = function (props) {
    return React.createElement(FluentIcon.PersonFeedback24Regular, props);
};
export var FeedbackIconSelected = function (props) {
    return React.createElement(FluentIcon.PersonFeedback24Filled, props);
};
export var MyContentIcon = function (props) {
    return React.createElement(FluentIcon.Folder24Regular, props);
};
export var MyContentIconSelected = function (props) {
    return React.createElement(FluentIcon.Folder24Filled, props);
};
export var PrepareIcon = function (props) {
    return React.createElement(FluentIcon.TextBulletListSquare24Regular, props);
};
export var PrepareIconSelected = function (props) {
    return React.createElement(FluentIcon.TextBulletListSquare24Filled, props);
};
export var WorkplaceIcon = function (props) {
    return React.createElement(FluentIcon.BriefcasePerson24Regular, props);
};
export var WorkplaceIconSelected = function (props) {
    return React.createElement(FluentIcon.BriefcasePerson24Filled, props);
};
export var CatchUpIcon = function (props) {
    return React.createElement(FluentIcon.Glance24Regular, props);
};
export var CatchUpIconSelected = function (props) {
    return React.createElement(FluentIcon.Glance24Filled, props);
};
export var CollectIcon = function (props) {
    return React.createElement(FluentIcon.DocumentOnePageMultiple24Regular, props);
};
export var CollectIconSelected = function (props) {
    return React.createElement(FluentIcon.DocumentOnePageMultiple24Filled, props);
};
export var NewsIcon = function (props) {
    return React.createElement(FluentIcon.News24Regular, props);
};
export var NewsIconSelected = function (props) {
    return React.createElement(FluentIcon.News24Filled, props);
};
export var CatchupIcon = function (props) {
    return React.createElement(FluentIcon.DocumentCatchUp20Regular, props);
};
export var CatchupIconSelected = function (props) {
    return React.createElement(FluentIcon.DocumentCatchUp20Filled, props);
};
export var AssistIcon = function (props) {
    return React.createElement(FluentIcon.ChatHelp20Regular, props);
};
export var AssistIconSelected = function (props) {
    return React.createElement(FluentIcon.ChatHelp20Filled, props);
};
export var ActionsIcon = function (props) {
    return React.createElement(ActionsIconRegular, props);
};
export var ActionsIconSelected = function (props) {
    return React.createElement(ActionsIconFilled, props);
};
export var ArrowRightIcon = function (props) {
    return React.createElement(FluentIcon.ArrowRight24Filled, props);
};
export var ActivityIcon = function (props) {
    return React.createElement(FluentIcon.Alert24Regular, props);
};
export var ActivityIconSelected = function (props) {
    return React.createElement(FluentIcon.Alert24Filled, props);
};
export var ChatIcon = function (props) {
    return React.createElement(FluentIcon.Chat24Regular, props);
};
export var ChatIconSelected = function (props) {
    return React.createElement(FluentIcon.Chat24Filled, props);
};
export var AiHubSampleIcon = function (props) {
    return React.createElement(FluentIcon.BeakerEdit24Regular, props);
};
export var AiHubSampleIconSelected = function (props) {
    return React.createElement(FluentIcon.BeakerEdit24Filled, props);
};
export var TeamsIcon = function (props) {
    return React.createElement(FluentIcon.PeopleTeam24Regular, props);
};
export var TeamsIconSelected = function (props) {
    return React.createElement(FluentIcon.PeopleTeam24Filled, props);
};
export var TeamsCalendarIcon = function (props) {
    return React.createElement(FluentIcon.CalendarLtr24Regular, props);
};
export var TeamsCalendarIconSelected = function (props) {
    return React.createElement(FluentIcon.CalendarLtr24Filled, props);
};
export var TeamsCalendarErrorIcon = function (props) {
    return React.createElement(FluentIcon.CalendarError24Regular, props);
};
export var TeamsCalendarErrorIconSelected = function (props) {
    return React.createElement(FluentIcon.CalendarError24Filled, props);
};
export var CallsIcon = function (props) {
    return React.createElement(FluentIcon.Call24Regular, props);
};
export var CallsIconSelected = function (props) {
    return React.createElement(FluentIcon.Call24Filled, props);
};
export var PersonSupportIcon = function (props) {
    return React.createElement(FluentIcon.PersonSupport24Regular, props);
};
export var PersonSupportIconSelected = function (props) {
    return React.createElement(FluentIcon.PersonSupport24Filled, props);
};
export var FilesIcon = function (props) {
    return React.createElement(FluentIcon.Document24Regular, props);
};
export var FilesIconSelected = function (props) {
    return React.createElement(FluentIcon.Document24Filled, props);
};
export var MeetIcon = function (props) {
    return React.createElement(FluentIcon.Video24Regular, props);
};
export var MeetIconSelected = function (props) {
    return React.createElement(FluentIcon.Video24Filled, props);
};
export var MailIcon = function (props) {
    return React.createElement(FluentIcon.Mail20Regular, props);
};
export var MailIconSelected = function (props) {
    return React.createElement(FluentIcon.Mail20Filled, props);
};
export var OutlookCalendarIcon = function (props) {
    return React.createElement(FluentIcon.CalendarLtr20Regular, props);
};
export var OutlookCalendarIconSelected = function (props) {
    return React.createElement(FluentIcon.CalendarLtr20Filled, props);
};
export var PeopleIcon = function (props) {
    return React.createElement(FluentIcon.People20Regular, props);
};
export var PeopleIconSelected = function (props) {
    return React.createElement(FluentIcon.People20Filled, props);
};
export var TeamsPeopleIcon = function (props) {
    return React.createElement(FluentIcon.People24Regular, props);
};
export var TeamsPeopleIconSelected = function (props) {
    return React.createElement(FluentIcon.People24Filled, props);
};
export var OutlookGroupsIcon = function (props) {
    return React.createElement(FluentIcon.PeopleCommunity20Regular, props);
};
export var OutlookGroupsIconSelected = function (props) {
    return React.createElement(FluentIcon.PeopleCommunity20Filled, props);
};
export var OutlookFilesIcon = function (props) {
    return React.createElement(FluentIcon.Attach20Regular, props);
};
export var OutlookFilesIconSelected = function (props) {
    return React.createElement(FluentIcon.Attach20Filled, props);
};
export var OutlookToDoIcon = function (props) {
    return React.createElement(FluentIcon.TaskListLtr20Regular, props);
};
export var OutlookToDoIconSelected = function (props) {
    return React.createElement(FluentIcon.TaskListLtr20Filled, props);
};
export var OutlookTasksIcon = function (props) {
    return React.createElement(FluentIcon.TasksApp20Regular, props);
};
export var OutlookTasksIconSelected = function (props) {
    return React.createElement(FluentIcon.TasksApp20Filled, props);
};
export var OutlookSpacesIcon = function (props) {
    return React.createElement(FluentIcon.Collections20Regular, props);
};
export var OutlookSpacesIconSelected = function (props) {
    return React.createElement(FluentIcon.Collections20Filled, props);
};
export var OutlookEventifyIcon = function (props) {
    return React.createElement(FluentIcon.Megaphone20Regular, props);
};
export var OutlookEventifyIconSelected = function (props) {
    return React.createElement(FluentIcon.Megaphone20Filled, props);
};
export var OutlookOrgExplorerIcon = function (props) {
    return React.createElement(FluentIcon.Organization20Regular, props);
};
export var OutlookOrgExplorerIconSelected = function (props) {
    return React.createElement(FluentIcon.Organization20Filled, props);
};
export var StoreIcon = function (props) {
    return React.createElement(FluentIcon.AppFolder24Regular, props);
};
export var StoreIconSelected = function (props) {
    return React.createElement(FluentIcon.AppFolder24Filled, props);
};
export var AppsIcon = function (props) {
    return props.size === 'default'
        ? React.createElement(FluentIcon.Apps20Regular, props)
        : React.createElement(FluentIcon.Apps24Regular, props);
};
export var AppsIconSelected = function (props) {
    return props.size === 'default'
        ? React.createElement(FluentIcon.Apps20Filled, props)
        : React.createElement(FluentIcon.Apps24Filled, props);
};
export var FeedIcon = function (props) {
    return React.createElement(FluentIcon.Feed24Regular, props);
};
export var FeedIconSelected = function (props) {
    return React.createElement(FluentIcon.Feed24Filled, props);
};
export var AppsIcon20 = function (props) {
    return React.createElement(FluentIcon.Apps20Regular, props);
};
export var AppGalleryIcon = function (props) {
    return React.createElement(FluentIcon.AddSquare24Regular, props);
};
export var AppGalleryIconSelected = function (props) {
    return React.createElement(FluentIcon.AddSquare24Filled, props);
};
export var AddSquareIcon = function (props) {
    return React.createElement(FluentIcon.AddSquare20Regular, props);
};
export var TeamsStoreIcon = function (props) {
    return React.createElement(FluentIcon.AddSquare24Regular, props);
};
export var TeamsStoreIconSelected = function (props) {
    return React.createElement(FluentIcon.AddSquare24Filled, props);
};
export var OutlookPhoneIcon = function (props) {
    return React.createElement(FluentIcon.Phone20Regular, props);
};
export var OutlookPhoneIconSelected = function (props) {
    return React.createElement(FluentIcon.Phone20Filled, props);
};
export var OutlookNewslettersIcon = function (props) {
    return React.createElement(FluentIcon.ContentView20Regular, props);
};
export var OutlookNewslettersIconSelected = function (props) {
    return React.createElement(FluentIcon.ContentView20Filled, props);
};
export var PinIcon = function (props) {
    return React.createElement(FluentIcon.Pin20Regular, props);
};
export var PinOffIcon = function (props) {
    return React.createElement(FluentIcon.PinOff20Regular, props);
};
export var SearchIcon = function (props) {
    return React.createElement(FluentIcon.Search20Regular, props);
};
export var SearchIconSelected = function (props) {
    return React.createElement(FluentIcon.Search20Filled, props);
};
export var SettingsIcon = function (props) {
    return React.createElement(FluentIcon.Settings20Regular, props);
};
export var AssignmentsIcon = function (props) {
    return React.createElement(FluentIcon.Backpack24Regular, props);
};
export var AssignmentsIconSelected = function (props) {
    return React.createElement(FluentIcon.Backpack24Filled, props);
};
export var PresenceBlockedIcon = function (props) {
    return React.createElement(FluentIcon.PresenceBlocked20Regular, props);
};
export var ProhibitIcon = function (props) {
    return React.createElement(FluentIcon.Prohibited20Regular, props);
};
export var EyeIcon = function (props) {
    return React.createElement(FluentIcon.Eye20Regular, props);
};
export var ShareGenericIcon = function (props) {
    return React.createElement(FluentIcon.Share20Regular, props);
};
export var ComposeIcon = function (props) {
    return React.createElement(FluentIcon.Compose20Regular, props);
};
export var InfoIcon = function (props) {
    return React.createElement(FluentIcon.Info20Regular, props);
};
export var PopupIcon = function (props) {
    return React.createElement(FluentIcon.WindowNew24Regular, props);
};
export var AlpsIcon = function (props) {
    return React.createElement(FluentIcon.MountainTrail24Regular, props);
};
export var AlpsIconSelected = function (props) {
    return React.createElement(FluentIcon.MountainTrail24Filled, props);
};
export var BrowseIcon = function (props) {
    return React.createElement(FluentIcon.SlideSearch24Regular, props);
};
export var BrowseIconSelected = function (props) {
    return React.createElement(FluentIcon.SlideSearch24Filled, props);
};
//# sourceMappingURL=AppBarIcons.js.map